import { DetailsRow, IDetailsRowProps } from "@bps/fluent-ui";
import { QueryStateIndicator } from "@components/QueryStateIndicator";
import { SoftwarePackageVersion } from "@libs/api/gateways/field/field-ops-gateway.dtos";
import { useSoftwarePackageVersions } from "@libs/api/gateways/field/field-ops-gateway.hooks";

export interface SelectSoftwarePackageVersionTableRowProps
  extends IDetailsRowProps {}

export const SelectSoftwarePackageVersionTableRow = (
  props: SelectSoftwarePackageVersionTableRowProps
) => {
  // Try obtain software package versions
  const softwarePackageVersionsQuery = useSoftwarePackageVersions({
    softwarePackageId: props.item.softwarePackageId
  });

  // Make row disabled if no versions are available
  return (
    <QueryStateIndicator<SoftwarePackageVersion[]>
      allowNullOrUndefined={true}
      {...softwarePackageVersionsQuery}
    >
      {softwarePackageVersions => {
        const noVersions = !(softwarePackageVersions?.length > 0);

        return <DetailsRow {...props} disabled={noVersions} />;
      }}
    </QueryStateIndicator>
  );
};
